// İş Emrini Hazırla (toplayıcı + araba + başlat) sihirbazı kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'wms.waveSetupWizard';

export const wmsWaveSetupWizardGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'İş emri nasıl hazırlanıp başlatılır?'),
  intro: t(`${G}.intro`, 'Üç adımda iş emrine toplayıcı ve araba verip toplamayı başlatırsınız. Seçimler "Başlat"a basana kadar kaydedilmez; "İptal" her şeyi geri alır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'İş Emrini Hazırla ve iş emri no'),
    tabs: t(`${G}.regions.tabs`, 'Adımlar'),
    body: t(`${G}.regions.body`, 'Adım içeriği'),
    footer: t(`${G}.regions.footer`, 'Geri / İptal / İleri / Başlat'),
  },
  navItems: [
    t(`${G}.nav.picker`, 'Toplayıcı'),
    t(`${G}.nav.cart`, 'Araba'),
    t(`${G}.nav.summary`, 'Özet & Başlat'),
  ],
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Toplayıcıyı seçin'),
      text: t(`${G}.s1.text`, '"Toplayıcı" listesinden personeli seçin. Listede bu depodaki Toplama ekranına yetkili personel çıkar; depoda Toplama ekranı yoksa uyarı verilir ve tüm personel listelenir. Toplayıcı seçmeden ilerlenemez.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Arabayı seçin'),
      text: t(`${G}.s2.text`, 'Depodaki aktif arabalar listelenir. "Müsait" olanları ya da bu iş emrine zaten bağlı olanı ("Mevcut") seçebilirsiniz; başka işte kullanılan araba seçilemez. Uygun araba yoksa Ekipman Yönetimi\'nden araba ekleyin veya boşaltın.'),
      tips: [
        t(`${G}.s2.tip1`, 'Arabanın tipi iş emrinin tipine uymalıdır: tekli araba tekli, çoklu araba çoklu iş emrine verilir; "Her ikisi" tipindeki araba her iş emrinde kullanılabilir. Uymazsa "Başlat"ta hata verilir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Özeti kontrol edin'),
      text: t(`${G}.s3.text`, '"Özet & Başlat" adımında seçilen Toplayıcı ve Araba görünür. Değiştirmek için "Geri" ile önceki adıma dönün.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Başlatın'),
      text: t(`${G}.s4.text`, '"Başlat" önce değişen toplayıcı ve araba atamalarını kaydeder, sonra iş emrini başlatır: durum "Devam Ediyor" olur, siparişler toplamaya alınır ve toplayıcı el terminalinde iş emrini görür.'),
      tips: [
        t(`${G}.s4.tip1`, 'Başlatma başarısız olursa hata mesajı gösterilir; bu arada kaydedilen atamalar kalmış olabilir, liste güncel durumu gösterecek şekilde yenilenir.'),
        t(`${G}.s4.tip2`, 'Sihirbaz, eksik ilk adımdan açılır: toplayıcı atanmışsa doğrudan Araba adımına geçer.'),
      ],
    },
  ],
});
